module.exports = __webpack_public_path__ + "static/media/pexels-photo-1798130.768066d9.jpg";